import { CreateAddressPayload } from "../../../api/types/address";
import { regex } from "../../../common/regex";
import { FormErrors } from "../../FieldError"

export const validateAddress = (address: CreateAddressPayload): [boolean, FormErrors<CreateAddressPayload>] => {
  let isValid: boolean = true;
  let errors: FormErrors<CreateAddressPayload> = {}

  if (!address.name) {
    errors.name = "Název společnosti je povinné pole."
    isValid = false
  }

  if (!address.street) {
    errors.street = "Ulice a číslo domu je povinné pole."
    isValid = false
  }

  if (!address.zip) {
    errors.zip = "PSČ je povinné pole."
    isValid = false
  }

  if (!address.city) {
    errors.city = "Obec je povinné pole."
    isValid = false
  }

  if (!address.country) {
    errors.country = "Země je povinné pole."
    isValid = false
  }

  if (address.country === "CZ") {
    if (!address.ic) {
      errors.ic = "IČ je povinné pole."
      isValid = false
    } else {
      if (!regex.IC.test(address.ic)) {
        errors.ic = "IČ není ve správném formátu."
        isValid = false
      }
    }
  }

  if (!address.dic) {
    errors.dic = "DIČ je povinné pole."
    isValid = false
  } else {
    if (!regex.DIC.test(address.dic)) {
      errors.dic = "DIČ není ve správném formátu."
      isValid = false
    }
  }

  return [isValid, errors]
}
